/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetUserResponse, User, UserListItem } from 'src/app/models/user';
import { UserAccess } from 'src/app/models/useraccess';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  env = environment;

  constructor(private http: HttpClient) {}

  searchADUsers(query: string): Promise<any[]> {
    const url = `${this.env.apiUrl}/users/searchADUsers/${query}`;
    const res$ = this.http.get<any>(url).pipe(
      map((res) => {
        if (Array.isArray(res)) return res;
        if (Array.isArray(res?.users)) return res.users;
        if (Array.isArray(res?.results)) return res.results;
        if (Array.isArray(res?.adUsers)) return res.adUsers;
        return [];
      }),
      catchError(() => of([]))
    );
    return firstValueFrom(res$);
  }

  /** Get users list from getUser API (array of users or wrapped { users, x_status }) */
  getUsers(): Promise<UserListItem[]> {
    const users$ = this.http
      .get<UserListItem[] | GetUserResponse>(`${this.env.apiUrl}/users`)
      .pipe(
        map((res) => {
          if (Array.isArray(res)) return res;
          if (res?.x_status === 'S' && Array.isArray((res as GetUserResponse).users)) {
            return (res as GetUserResponse).users!;
          }
          return [];
        }),
        catchError(() => of([]))
      );
    return firstValueFrom(users$);
  }

  //GET ALL USERS
  getAllUsers(): Promise<User[]> {
    const users$ = this.http
      .get(`${this.env.apiUrl}/users?&take=1000&skip=0`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((err) => {
          return of(err);
        })
      );
    return firstValueFrom(users$);
  }

  // Get a single user
  getById(userId: string): Observable<User> {
    const url = `${this.env.apiUrl}/users/${userId}`;
    return this.http.get(url, { observe: 'response' }).pipe(
      map((data: any) => {
        return data.body;
      }),
    );
  }

  // Create a user
  create(user: User): Observable<User> {
    const url = `${this.env.apiUrl}/users`;
    return this.http.post(url, user, { observe: 'response' }).pipe(
      map((data: any) => {
        return data.body;
      }),
    );
  }

  // Update a user
  update(user: User): Observable<any> {
    const url = `${this.env.apiUrl}/users/${user.userId}`;
    return this.http.put(url, user, { observe: 'response' }).pipe(
      map((data: any) => {
        return data.body;
      }),
    );
  }

  // Get a single user
  getAccessByUserId(userId: string): Promise<any> {
    const url = `${this.env.apiUrl}/users/access/${userId}`;
    const res$ = this.http.get(url, { observe: 'response' }).pipe(
      map((data: any) => {
        return data.body;
      }),
      catchError(error => of(error))
    );
    return firstValueFrom(res$);
  }

  // Get a single user
  getAccessByLocSeq(locSeq: number): Observable<any> {
    const url = `${this.env.apiUrl}/users/access/locSeq/${locSeq}`;
    return this.http.get(url, { observe: 'response' }).pipe(
      map((data: any) => {
        return data.body;
      }),
    );
  }

  // Update user security
  updateUserAccess(userId: string, userAccess: UserAccess[]): Observable<any> {
    const url = `${this.env.apiUrl}/users/access/${userId}`;
    const body = userAccess;
    return this.http.post(url, body, { observe: 'response' }).pipe(
      map((data: any) => {
        return data.body;
      }),
    );
  }


}
